import axios from 'axios'

const auth = axios.create()
auth.defaults.baseURL = `${process.env.VUE_APP_API_URL}/auth/`
auth.defaults.timeout = 20000

const successHandler = (response) => response.data
const errorHandler = (error) => {
  if (!!process.env.VUE_APP_DEBUG) {
    console.warn(`${error.response.config.method.toUpperCase()}: ${error.response.config.url}`, error.response)
  }
  return Promise.reject(error.response)
}

auth.interceptors.response.use(successHandler, errorHandler)

export default auth
